/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class About extends Component {
  render() {
    return (
      <div>
        Page About
      </div>
    );
  }
}

export default withRouter(About);
